// chart-options.interface.ts
export interface ChartDataI {
  // ECharts/ApexCharts axis option bags — no SDK types are installed in this
  // workspace, so these stay dynamic. Typed `unknown` (not `any`) to force a
  // narrow/cast at any future read site (cf. the documented escape in dashboard.ts).
  xAxis: unknown;
  yAxis: unknown;
  series: ChartSeriesI[];
}

export interface ChartSeriesI {
  name: string;
  type: string;
  data: number[];
  // ... other properties as needed
}
